import styled, { css } from 'styled-components'
import theme from 'theme_'

export const CommonStyledFooter = styled.footer`
  display: flex;
  padding-right: ${theme.spacing.lg};
  padding-left: ${theme.spacing.lg};
  color: ${theme.colors.otterWarmBlack};
  background-color: ${theme.colors.grey};

  @media ${theme.devices.mobile} {
    padding: 16px;
  }
`

export const FooterWrapper = styled(CommonStyledFooter)<{ aside: boolean }>`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: ${theme.spacing.sm};
  background: ${theme.colors.white};
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0) 100%
  );

  ${(p) =>
    p.aside &&
    css`
      @media ${theme.devices.tablet} {
        padding-left: 120px;
      }

      @media ${theme.devices.mediumDesktop} {
        padding-left: 320px;
      }

      @media screen and (min-width: 1440px) {
        padding-left: calc(
          ((100vw - ${theme.sizes.maxContentWidth}) / 2) + 320px
        );
      }
    `}

  @media ${theme.devices.tablet} {
    padding-top: 0px;
  }

  @media ${theme.devices.desktop} {
    padding-top: ${theme.spacing.large};
  }

  @media ${theme.devices.mobile} {
    display: block;
    padding-top: 32px;
  }
`

export const FooterNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const FooterLinksContainer = styled.div`
  display: grid;
  column-gap: 70px;

  @media ${theme.devices.tablet} {
    grid-template-columns: auto auto;
    margin-top: 24px;
  }

  @media ${theme.devices.desktop} {
    grid-template-columns: auto auto auto;
    margin-top: 24px;
  }

  @media ${theme.devices.mobile} {
    grid-template-columns: auto auto;
    margin-top: 24px;
    column-gap: 20px;
  }
`

export const StyledFooterLink = styled.a`
  color: ${theme.colors.duneWarmGrey};
  text-decoration: none;
  display: list-item;
  list-style-position: inside;

  &:hover {
    color: ${theme.colors.horizonOrange};
  }

  @media ${theme.devices.tablet} {
    font-size: 12px;
    padding-bottom: 16px;
  }

  @media ${theme.devices.desktop} {
    font-size: 14px;
    padding-bottom: 8px;
  }

  @media ${theme.devices.mobile} {
    font-size: 12px;
    padding-bottom: 16px;
  }
`

export const FooterName = styled.div`
  margin-bottom: 8px;
  font-weight: bold;
`
